<div
  *ngIf="isPanelOnActiveTab$ | async; else notActive"
  class="d-flex flex-column w-100 h-100"
>
  <!--https://medium.com/@pietmichal/angulars-content-projection-trap-and-why-you-should-consider-using-template-outlet-instead-cc3c4cad87c9-->
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</div>

<ng-template #notActive>
  <hs-panel-card
    class="d-flex flex-column w-100 h-100"
    header="Panel is not currently active"
  >
    <p>This panel is not currently on an active tab.</p>
  </hs-panel-card>
</ng-template>
